import React, { useEffect } from "react";

import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { StyledRadio } from "../../../../../utils/designComponents/StyledRadio";

const brokerages = [
  { label: "TRADIER", value: "TRADIER" },
  { label: "SIMULATED", value: "BACKTEST" },
];

const Brokerage = (props) => {
  let top = props.top;
  let dispatchTop = props.dispatchTop;
  //let setSavedConfigChanged = props.setSavedConfigChanged;

  useEffect(() => {
    if (top.accountNumber === "BACKTEST" && top.brokerage !== "BACKTEST") {
      dispatchTop({ brokerage: "BACKTEST" });
    }
  }, [top.accountNumber]);
  return (
    <div>
      <FormControl component="fieldset" variant="outlined">
        <RadioGroup
          row
          aria-label="brokerage"
          name="brokerage"
          value={top.brokerage}
          onChange={(ev) => {
            dispatchTop({ brokerage: ev.target.value });
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="baseline"
            spacing={2}
          >
            <Grid item>
              <Typography style={{ fontSize: 12 }} color="textSecondary">
                Brokerage:
              </Typography>
            </Grid>
            <Grid item>
              {top.dataSource === "SIMULATED" || top.dataSource === "REPLAY" ? (
                <FormControlLabel
                  value="BACKTEST"
                  control={<StyledRadio />}
                  label={
                    <Typography style={{ fontSize: 12 }}>SIMULATED</Typography>
                  }
                />
              ) : (
                brokerages.map((e) => {
                  //  if (e === "TRADIER") {
                  return (
                    <FormControlLabel
                      key={e.value}
                      value={e.value}
                      control={<StyledRadio />}
                      label={
                        <Typography style={{ fontSize: 10 }}>
                          {e.label}
                        </Typography>
                      }
                    />
                  );
                  //}
                })
              )}
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default Brokerage;
